import { styled } from 'styled-components';

export const Wrapper = styled.div`
    position: absolute;
    top: 5px;
    right: 5px;
`;

export const ShareOptions = styled.div`
    width: 100%;
    display: flex;

    @media (max-width: 768px) {
        justify-content: center;
    }
`;
